import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, InputGroup, Button, Image, Carousel, Card, ButtonGroup } from "react-bootstrap";
import "../css/home.css";
import CountUp from "react-countup";
import "../css/card.css";
import animationData from '../json/Animation.json';
import Lottie from 'react-lottie';  // Ensure this import is at the top
import TradingImage from "../img/images/man1-01.png";
import Web1 from '../img/images/w1-01.png';
import Web2 from '../img/images/d1.png';
import Web3 from '../img/web.png';
import Web4 from '../img/windows.png';
import Image1 from '../img/images/image1-01.png'
import Image2 from '../img/images/p5-01.png'
import Image3 from '../img/images/p4-01.png'
import Image4 from '../img/images/p2-01.png'
import Image5 from '../img/images/p1-01.png'
import Image6 from '../img/images/p3-01.png'
import Image7 from '../img/images/stock-01.png'
import img1 from '../img/1.png'
import img2 from '../img/2 (1).png'
import img3 from '../img/3.png'
import img4 from '../img/4.png'
import img5 from '../img/5.png'
// import img6 from '../img/images/Untitled-3-01.png'

import Repeat from '../img/images/fc7a631a5f608d7e9a45e243a9d8c3e0.png'
import Stock from '../img/images/p7-01.png'
import Fund from '../img/images/p10-01.png'
import IPO from '../img/images/p9-01.png'
import Security from '../img/images//p6.png'
import Gold from '../img/images/p8-01.png'
import OurPro from '../img/images/09-01.png'
import Mock from '../img/images/mockup-1.png'
import Icon1 from '../img/images/icon-2.png'
import Icon2 from '../img/images/Untitled-5-01.png'
import Icon3 from '../img/images/i4-01.png'
import Icon4 from '../img/images/133-01.png'
import Countimg from '../img/images/about1.png'

import Client from '../img/images/7.png'
import Client1 from '../img/images/flexibility.png'
import Client2 from '../img/images/ipo.png'
import Client3 from '../img/images/systems.png'
import Client4 from '../img/images/app-development.png'
import Client5 from '../img/images/calculator.png'
import Client6 from '../img/images/webinar.png'
import Client7 from '../img/images/api-integration.png'
import Project from '../img/images/879.png'
import Project5 from '../img/images/project__5.png'
import Project6 from '../img/images/project__6.png'
import Project7 from '../img/images/project__7.png'
import Project8 from '../img/images/876.png'
import Project9 from '../img/images/878.png'
import Award1 from '../img/images/344-01.png'
import Award2 from '../img/images/aw1-01.png'
import Award3 from '../img/images/aw1-01.png'
const BannerSection = () => {


    const [number, setNumber] = useState([0, 0, 0, 0, 0, 0, 0]); // Initial state with zeros
    const [date, setDate] = useState({
        day: "00",
        month: "Month",
        year: "0000",
        dayName: "Day",
    });

    // Get current date
    useEffect(() => {
        const now = new Date();
        const options = { month: "long" }; // Get full month name
        const dayOptions = { weekday: "long" }; // Get full day name (e.g., Saturday)

        setDate({
            day: String(now.getDate()).padStart(2, "0"), // Ensure two-digit format
            month: new Intl.DateTimeFormat("en-US", options).format(now), // Month name
            year: now.getFullYear().toString(), // Year
            dayName: new Intl.DateTimeFormat("en-US", dayOptions).format(now), // Day name
        });
    }, []);

    // Animate numbers one by one
    useEffect(() => {
        const finalNumbers = [5, 9, 2, 3, 8, 9, 4]; // Target count values
        finalNumbers.forEach((num, i) => {
            setTimeout(() => {
                setNumber((prev) => {
                    const newNumbers = [...prev];
                    newNumbers[i] = num;
                    return newNumbers;
                });
            }, i * 1000); // Delay each digit animation
        });
    }, []);










    const cardStyle = {
        backgroundColor: "#1e293b",
        color: "white",
        padding: "15px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    };


    const titleStyle = {
        fontSize: "1.2rem",
        fontWeight: "bold",
    };

    const chartStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "10px",
    };

    const gaugeStyle = {
        width: "120px",
        height: "60px",
        background: "conic-gradient(yellow 0% 20%, lightgreen 20% 45%, green 45% 100%)",
        borderRadius: "60px 60px 0 0",
    };

    const legendStyle = {
        listStyleType: "none",
        padding: "10px 0 0",
        margin: "0",
        fontSize: "14px",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
    };
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredProject1, setIsHoveredProject1] = useState(false);
    const [isHoveredProject2, setIsHoveredProject2] = useState(false);
    const [isHoveredProject3, setIsHoveredProject3] = useState(false);
    // const number = "5923894".split("");


    const [activeIndex, setActiveIndex] = useState(0);

    const awardsTexts = [
        ["18+ years of Trust and Experience in the broking industry"],
        ["Contributed highest VOLUME IN ENERGY CONTRACTS in the year 2018"],
        ["Connectors of Commodity BUSINESS SOUTH in the year 2019"]
    ];



    const defaultOptions = {
        loop: true,
        autoplay: true, // Start animation automatically
        animationData: animationData, // Your Lottie JSON animation data
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    const images = [img1, img2, img3, img4, img5];  // Image sources
    const [currentIndex, setCurrentIndex] = useState(0);  // Start with the first image

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);  // Cycle through all images
        }, 6000); // Change images every 3 seconds
        return () => clearInterval(interval);
    }, [images.length]);




    const visibleImages = [
        images[(currentIndex) % images.length],  // First image (left)
        images[(currentIndex + 1) % images.length], // Middle image (center)
        images[(currentIndex + 2) % images.length]  // Last image (right)
    ];

    const backgroundImages = [Award1, Award2, Award3];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % awardsTexts.length); // Loop through the texts/images
        }, 3000); // Change every 3 seconds

        // Clean up interval when the component unmounts
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures it runs only once on mount



    return (
        <>



            {/* banner start */}






            <div className="banner-section">

                <div
                    style={{
                        backgroundColor: "#0f2f50",
                        color: "white",
                        padding: "50px 0",
                    }}
                >


                    <Container>
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="bannerheader">
                                    <span style={{ color: "#00A877", fontSize: '80px' }}>ZERO</span> <br />
                                    BROKERAGE <br />

                                </h1>

                                <h1> Plan for

                                    Individual, Corporate, NRI</h1>

                                <Button
                                    variant="outline-light"
                                    style={{
                                        marginTop: "20px",
                                        borderRadius: "5px",
                                        padding: "10px 20px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Open Account &nbsp; →
                                </Button>
                            </Col>

                            <Col md={6} className="text-center d-none d-md-block">
                                <img
                                    src={TradingImage}
                                    alt="Trading Chart"
                                    style={{
                                        maxWidth: "99%",
                                        borderRadius: "10px",
                                        marginRight: '-238px',
                                        marginBottom: '-50px',
                                        overflow: 'hidden'
                                    }}
                                    className="bannerimage"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>


            </div>


            {/* banner end */}
            <div className=" counter">
                <div

                >
                    <div style={{ background: "#071c32", color: "white", padding: "60px 0" }}>
                        <Container>
                            <Row>
                                <Col md={6} className="d-none d-md-flex justify-content-center align-items-center">
                                    <img src={Countimg} alt="Image" />
                                </Col>
                                <Col md={6} className="d-flex justify-content-center align-items-center flex-column text-center">
                                    <h1 style={{ fontSize: "55px" }}>Brokerage</h1>
                                    <h1 style={{ fontSize: "55px" }}>Saved Today</h1>
                                    <Row className="mt-4 justify-content-center">
                                        <Col>
                                            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                                                {number.map((digit, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            width: "40px",
                                                            height: "50px",
                                                            border: "2px solid white",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: "24px",
                                                            fontWeight: "bold",
                                                            background: "transparent",
                                                            fontFamily: "Courier, monospace",
                                                        }}
                                                    >
                                                        {digit}
                                                    </div>
                                                ))}
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </div>

                </div>

            </div>

            <section style={{ backgroundColor: "#00a877 " }}>
                <Container style={{ padding: "1.5rem 1rem" }}>
                    <Row style={{ display: "flex", justifyContent: "center", flexWrap: "nowrap", overflowX: "auto" }}>
                        <Col style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}>
                            <Button className="banner-button banner-button-web" href="/stocks/">
                                <img src={Client} alt="Web Trading" />
                                Web Trading
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client1} alt="Back Office" />
                                Back Office
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client2} alt="IPO" />
                                IPO
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client3} alt="Manage Account" />
                                Manage Account
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client4} alt="Wall" />
                                Wall
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client5} alt="Calculators" />
                                Calculators
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client6} alt="Education" />
                                Education
                            </Button>

                            <Button className="banner-button  banner-button-web">
                                <img src={Client7} alt="API" />
                                API
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* pto */}
            <div className="csr100">
                <h2 className="headerText" style={{ color: '#ffff', fontWeight: '700' }}>OUR PRODUCTS</h2>

                <div className="box mb-5">
                    <div className="card">
                        <a href="/futures-options">
                            <img
                                src={Image5}
                                alt="OTC"
                            />
                        </a>
                        <div className="text">Futures and Options</div>

                        <div className="card my-5">
                            <a href="/margin-trading">
                                <img
                                    src={Image4}
                                    alt="OTC"
                                />
                            </a>
                            <div className="text">Margin Trading Facility</div>
                        </div>
                    </div>

                    <div className="card-box card-box1">
                        <div className="card card1">
                            <a href="/exchange-traded-funds">
                                <img
                                    src={Image6}
                                    alt="Stocks"
                                />
                            </a>
                            <div className="text">Exchange Traded Funds</div>
                        </div>
                        <div className="card card1">
                            <a href="/currency">
                                <img
                                    src={Image3}
                                    alt="Stocks"
                                />
                            </a>
                            <div className="text">Currency</div>
                        </div>
                        <div className="card card1">
                            <a href="/commodity">
                                <img
                                    src={Image2}
                                    alt="Stocks"
                                />
                            </a>
                            <div className="text">Commodity</div>
                        </div>
                    </div>

                    <picture>

                        <img
                            src={OurPro}
                            className="img1"
                            loading="lazy"
                            alt="Diversify Your Investment Portfolio"
                        />
                    </picture>

                    <div className="card-box">
                        <div className="card card1">
                            <a href="/stock-sip">
                                <img
                                    src={Stock}
                                    alt="ETFs"
                                />
                            </a>
                            <div className="text">Stock SIP</div>
                        </div>
                        <div className="card card1">
                            <a href="/stock-sip">
                                <img
                                    src={Fund}
                                    alt="ETFs"
                                />
                            </a>
                            <div className="text">mutual Fund</div>
                        </div>
                        <div className="card card1">
                            <a href="/stock-sip">
                                <img
                                    src={IPO}
                                    alt="ETFs"
                                />
                            </a>
                            <div className="text">IPO</div>
                        </div>
                    </div>

                    <div className="card card">
                        <a href="#">
                            <img
                                src={Gold}
                                alt="Options"
                            />
                        </a>
                        <div className="text">Sovereign Gold Bond</div>

                        <div className="card card1" style={{ marginInline: 'none' }}>
                            <a href="#">
                                <img
                                    src={Security}
                                    alt="Options"
                                />
                            </a>
                            <div className="text">Goverment Securities</div>


                        </div>


                    </div>

                </div>
            </div>



            {/* <div class="container servicecard">
                <p class="container-title my-3
    ">OUR TECHNOLOGICALLY ADVANCED
                    INVESTMENT <br />AND TRADING ECOSYSTEM</p>

                <div class="gradient-cards">
                    <div class="card">
                        <div class="container-card bg-green-box">
                            <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="118" height="118" rx="24" fill="url(#paint0_linear_1366_4547)"
                                    fill-opacity="0.15" stroke="url(#paint1_radial_1366_4547)" stroke-width="2"></rect>
                                <path
                                    d="M33.2182 61.4C33.2182 75.425 37.2682 86.75 51.5932 86.75C65.9182 86.75 69.8182 75.425 69.8182 61.4C69.8182 47.225 65.9182 35.9 51.5932 35.9C37.2682 35.9 33.2182 47.225 33.2182 61.4ZM43.7182 61.4C43.7182 53.075 45.5932 46.1 51.5932 46.1C57.5182 46.1 59.3182 53.075 59.3182 61.4C59.3182 69.65 57.5182 76.55 51.5932 76.55C45.5932 76.55 43.7182 69.65 43.7182 61.4Z"
                                    fill="#54E8A9"></path>
                                <path
                                    d="M87.7143 36.35L78.0543 56H80.1243L89.7843 36.35H87.7143ZM74.6943 40.16C74.6943 42.44 76.4043 44.15 78.6843 44.15C80.9343 44.15 82.7043 42.44 82.7043 40.16C82.7043 37.91 80.9343 36.14 78.6843 36.14C76.4043 36.14 74.6943 37.91 74.6943 40.16ZM77.1243 40.16C77.1243 39.29 77.7543 38.57 78.6843 38.57C79.5543 38.57 80.2743 39.29 80.2743 40.16C80.2743 41.09 79.5543 41.72 78.6843 41.72C77.7543 41.72 77.1243 41.09 77.1243 40.16ZM85.3143 52.31C85.3143 54.59 87.0243 56.3 89.3043 56.3C91.5543 56.3 93.3243 54.59 93.3243 52.31C93.3243 50.06 91.5543 48.29 89.3043 48.29C87.0243 48.29 85.3143 50.06 85.3143 52.31ZM87.7443 52.31C87.7443 51.44 88.3743 50.72 89.3043 50.72C90.1743 50.72 90.8943 51.44 90.8943 52.31C90.8943 53.24 90.1743 53.87 89.3043 53.87C88.3743 53.87 87.7443 53.24 87.7443 52.31Z"
                                    fill="#2FCB89"></path>
                                <defs>
                                    <linearGradient id="paint0_linear_1366_4547" x1="0.0063367" y1="0.168432" x2="120.853"
                                        y2="119.009" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#2FCB89" stop-opacity="0.7"></stop>
                                        <stop offset="0.489583" stop-color="#2FCB89" stop-opacity="0"></stop>
                                        <stop offset="1" stop-color="#2FCB89" stop-opacity="0.7"></stop>
                                    </linearGradient>
                                    <radialGradient id="paint1_radial_1366_4547" cx="0" cy="0" r="1"
                                        gradientUnits="userSpaceOnUse"
                                        gradientTransform="translate(60 60) rotate(96.8574) scale(122.674 149.921)">
                                        <stop stop-color="#54E8A9"></stop>
                                        <stop offset="1" stop-color="#1A3E31" stop-opacity="0.2"></stop>
                                    </radialGradient>
                                </defs>
                            </svg>
                            <p class="card-title my-2">0 No Brokerage for Individuals, HUF & Corporates</p>
                            <p class="card-description">Absolutely No Brokerage on Equity Delivery, F&O, and Intraday across all segments NSE, BSE, and MCX.</p>
                        </div>
                    </div>

                    <div class="card1">
                        <div class="container-card bg-green-box">

                            <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="118" height="118" rx="24" fill="url(#paint0_linear_1366_4547)"
                                    fill-opacity="0.15" stroke="url(#paint1_radial_1366_4547)" stroke-width="2"></rect>
                                <path
                                    d="M33.2182 61.4C33.2182 75.425 37.2682 86.75 51.5932 86.75C65.9182 86.75 69.8182 75.425 69.8182 61.4C69.8182 47.225 65.9182 35.9 51.5932 35.9C37.2682 35.9 33.2182 47.225 33.2182 61.4ZM43.7182 61.4C43.7182 53.075 45.5932 46.1 51.5932 46.1C57.5182 46.1 59.3182 53.075 59.3182 61.4C59.3182 69.65 57.5182 76.55 51.5932 76.55C45.5932 76.55 43.7182 69.65 43.7182 61.4Z"
                                    fill="#54E8A9"></path>
                                <path
                                    d="M87.7143 36.35L78.0543 56H80.1243L89.7843 36.35H87.7143ZM74.6943 40.16C74.6943 42.44 76.4043 44.15 78.6843 44.15C80.9343 44.15 82.7043 42.44 82.7043 40.16C82.7043 37.91 80.9343 36.14 78.6843 36.14C76.4043 36.14 74.6943 37.91 74.6943 40.16ZM77.1243 40.16C77.1243 39.29 77.7543 38.57 78.6843 38.57C79.5543 38.57 80.2743 39.29 80.2743 40.16C80.2743 41.09 79.5543 41.72 78.6843 41.72C77.7543 41.72 77.1243 41.09 77.1243 40.16ZM85.3143 52.31C85.3143 54.59 87.0243 56.3 89.3043 56.3C91.5543 56.3 93.3243 54.59 93.3243 52.31C93.3243 50.06 91.5543 48.29 89.3043 48.29C87.0243 48.29 85.3143 50.06 85.3143 52.31ZM87.7443 52.31C87.7443 51.44 88.3743 50.72 89.3043 50.72C90.1743 50.72 90.8943 51.44 90.8943 52.31C90.8943 53.24 90.1743 53.87 89.3043 53.87C88.3743 53.87 87.7443 53.24 87.7443 52.31Z"
                                    fill="#2FCB89"></path>
                                <defs>
                                    <linearGradient id="paint0_linear_1366_4547" x1="0.0063367" y1="0.168432" x2="120.853"
                                        y2="119.009" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#2FCB89" stop-opacity="0.7"></stop>
                                        <stop offset="0.489583" stop-color="#2FCB89" stop-opacity="0"></stop>
                                        <stop offset="1" stop-color="#2FCB89" stop-opacity="0.7"></stop>
                                    </linearGradient>
                                    <radialGradient id="paint1_radial_1366_4547" cx="0" cy="0" r="1"
                                        gradientUnits="userSpaceOnUse"
                                        gradientTransform="translate(60 60) rotate(96.8574) scale(122.674 149.921)">
                                        <stop stop-color="#54E8A9"></stop>
                                        <stop offset="1" stop-color="#1A3E31" stop-opacity="0.2"></stop>
                                    </radialGradient>
                                </defs>
                            </svg>
                            <p class="card-title my-2">₹ 0 No Brokerage for NRI</p>
                            <p class="card-description">Zero Brokerage on all trades for NRIs — first time in India.Get funded for your investment at 18% interest per annum</p>
                        </div>
                    </div>
                    <div class="card1">
                        <div class="container-card bg-green-box">

                            <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="118" height="118" rx="24" fill="url(#paint0_linear_1366_4582)"
                                    fill-opacity="0.15" stroke="url(#paint1_radial_1366_4582)" stroke-width="2"></rect>
                                <path
                                    d="M90.9405 64.775L88.0155 69.55L85.1155 64.775H80.0655L85.5155 72.85L79.5905 82H84.4905L88.0155 76.175L91.5155 82H96.4405L90.4905 72.85L95.9405 64.775H90.9405Z"
                                    fill="#87A1FF"></path>
                                <path
                                    d="M44.9833 35.52L27.3433 43.92V52.53L35.1833 49.17V82H44.9833V35.52ZM71.37 35.52L53.73 43.92V52.53L61.57 49.17V82H71.37V35.52Z"
                                    fill="#87A1FF"></path>
                                <defs>
                                    <linearGradient id="paint0_linear_1366_4582" x1="120.194" y1="119.827" x2="-13.1225"
                                        y2="17.1841" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#61A0FF" stop-opacity="0.7"></stop>
                                        <stop offset="0.489583" stop-color="#61A0FF" stop-opacity="0"></stop>
                                        <stop offset="1" stop-color="#61A0FF" stop-opacity="0.7"></stop>
                                    </linearGradient>
                                    <radialGradient id="paint1_radial_1366_4582" cx="0" cy="0" r="1"
                                        gradientUnits="userSpaceOnUse"
                                        gradientTransform="translate(60 60) rotate(96.8574) scale(122.674 149.921)">
                                        <stop stop-color="#87A1FF"></stop>
                                        <stop offset="1" stop-color="#16161D" stop-opacity="0.2"></stop>
                                    </radialGradient>
                                </defs>
                            </svg>
                            <p class="card-title my-2 ">4XMTF Leverage</p>
                            <p class="card-description">Make investments even when you are short of funds. Get funded for your investments at 18% interest per annum.</p>
                        </div>
                    </div>


                    <div class="card">
                        <div class="container-card bg-green-box">
                            <svg width="80" height="80" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="118" height="118" rx="24" fill="url(#paint0_linear_1366_4557)"
                                    fill-opacity="0.15" stroke="url(#paint1_radial_1366_4557)" stroke-width="2"></rect>
                                <path
                                    d="M74.2105 36C73.373 36 72.5698 35.6839 71.9776 35.1213C71.3853 34.5587 71.0526 33.7956 71.0526 33C71.0526 32.2044 71.3853 31.4413 71.9776 30.8787C72.5698 30.3161 73.373 30 74.2105 30H86.8421C87.6796 30 88.4829 30.3161 89.0751 30.8787C89.6673 31.4413 90 32.2044 90 33V45C90 45.7956 89.6673 46.5587 89.0751 47.1213C88.4829 47.6839 87.6796 48 86.8421 48C86.0046 48 85.2014 47.6839 84.6091 47.1213C84.0169 46.5587 83.6842 45.7956 83.6842 45V40.242L65.3905 57.621C64.7983 58.1834 63.9953 58.4994 63.1579 58.4994C62.3205 58.4994 61.5175 58.1834 60.9253 57.621L52.1053 49.242L35.3905 65.121C34.7949 65.6675 33.9972 65.9699 33.1693 65.963C32.3413 65.9562 31.5492 65.6407 30.9637 65.0845C30.3782 64.5282 30.0461 63.7758 30.0389 62.9892C30.0317 62.2026 30.35 61.4448 30.9253 60.879L49.8726 42.879C50.4648 42.3166 51.2679 42.0006 52.1053 42.0006C52.9426 42.0006 53.7457 42.3166 54.3379 42.879L63.1579 51.258L79.219 36H74.2105ZM36.3158 78V87C36.3158 87.7957 35.9831 88.5587 35.3909 89.1213C34.7986 89.6839 33.9954 90 33.1579 90C32.3204 90 31.5171 89.6839 30.9249 89.1213C30.3327 88.5587 30 87.7957 30 87V78C30 77.2043 30.3327 76.4413 30.9249 75.8787C31.5171 75.3161 32.3204 75 33.1579 75C33.9954 75 34.7986 75.3161 35.3909 75.8787C35.9831 76.4413 36.3158 77.2043 36.3158 78ZM52.1053 66C52.1053 65.2043 51.7726 64.4413 51.1803 63.8787C50.5881 63.3161 49.7849 63 48.9474 63C48.1098 63 47.3066 63.3161 46.7144 63.8787C46.1222 64.4413 45.7895 65.2043 45.7895 66V87C45.7895 87.7957 46.1222 88.5587 46.7144 89.1213C47.3066 89.6839 48.1098 90 48.9474 90C49.7849 90 50.5881 89.6839 51.1803 89.1213C51.7726 88.5587 52.1053 87.7957 52.1053 87V66ZM64.7368 69C65.5744 69 66.3776 69.3161 66.9698 69.8787C67.562 70.4413 67.8947 71.2043 67.8947 72V87C67.8947 87.7957 67.562 88.5587 66.9698 89.1213C66.3776 89.6839 65.5744 90 64.7368 90C63.8993 90 63.0961 89.6839 62.5039 89.1213C61.9117 88.5587 61.5789 87.7957 61.5789 87V72C61.5789 71.2043 61.9117 70.4413 62.5039 69.8787C63.0961 69.3161 63.8993 69 64.7368 69ZM83.6842 57C83.6842 56.2044 83.3515 55.4413 82.7593 54.8787C82.1671 54.3161 81.3638 54 80.5263 54C79.6888 54 78.8856 54.3161 78.2933 54.8787C77.7011 55.4413 77.3684 56.2044 77.3684 57V87C77.3684 87.7957 77.7011 88.5587 78.2933 89.1213C78.8856 89.6839 79.6888 90 80.5263 90C81.3638 90 82.1671 89.6839 82.7593 89.1213C83.3515 88.5587 83.6842 87.7957 83.6842 87V57Z"
                                    fill="#FFEE24"></path>
                                <defs>
                                    <linearGradient id="paint0_linear_1366_4557" x1="-0.0208152" y1="-0.102528" x2="119.899"
                                        y2="119.817" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE34B" stop-opacity="0.7"></stop>
                                        <stop offset="0.510417" stop-color="#FFE34B" stop-opacity="0"></stop>
                                        <stop offset="1" stop-color="#FFE34B" stop-opacity="0.7"></stop>
                                    </linearGradient>
                                    <radialGradient id="paint1_radial_1366_4557" cx="0" cy="0" r="1"
                                        gradientUnits="userSpaceOnUse"
                                        gradientTransform="translate(60 60) rotate(96.8574) scale(122.674 149.921)">
                                        <stop stop-color="#FFEE24"></stop>
                                        <stop offset="1" stop-color="#302A1A" stop-opacity="0.2"></stop>
                                    </radialGradient>
                                </defs>
                            </svg>
                            <p class="card-title mt-2">Multiple Exchanges</p>
                            <p class="card-description">Invest in various financial assets present across multiple exchanges to build a robust portfolio and increase your returns.</p>
                        </div>
                    </div>
                </div>
            </div> */}


            <section className="apps-section " style={{ background: '#071c32' }}>
                <div className="auto-container">
                    <div className="inner-container">
                        <div
                            className="shape shape1"

                        ></div>
                        <figure className="image-layer">
                            <img className='appimage' src={Mock} alt="" />
                        </figure>
                        <div className="content_block_two">
                            <div className="content-box">
                                <div className="sec-title light pb_40">
                                    {/* <span className="sub-title mb_14">Trading</span> */}
                                    <h2>Trading Platforms</h2>

                                </div>
                                <ul className="download-list clearfix">
                                    <li>
                                        <a href="index.html">
                                            <img className='img1'
                                                src={Icon4}
                                                alt="Download Icon"
                                            />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="index.html">
                                            <img className='img1'
                                                src={Icon1}
                                                alt="Download Icon"
                                            />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="index.html">
                                            <img className='img1'
                                                src={Icon2}
                                                alt="Download Icon"
                                            />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="index.html">
                                            <img className='img1'
                                                src={Icon3}
                                                alt="Download Icon"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* download */}


            {/* download appp */}





            {/* award */}


            <section className="awrds-sec bg-white">
                <h2 className="awrds-hdr" style={{ fontSize: '50px' }}>
                    20+ Years Of Trust & Awards
                </h2>
                <div className="otrmrl">
                    <div className="inrmrl">
                        <div
                            className="awrds-cnt"
                            style={{
                                backgroundImage: `url(${backgroundImages[activeIndex]})`, // Dynamically set background image based on activeIndex
                            }}
                        >
                            <div className="awrds-inrcnt">
                                {awardsTexts.map((text, index) => (
                                    <span
                                        key={index}
                                        className={`awrds-pra ${index === activeIndex ? "show" : ""}`} // Dynamically show/hide text
                                    >
                                        {text}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="awrds-dts">
                    {/* Optional: Navigation dots */}
                    {awardsTexts.map((_, index) => (
                        <span
                            key={index}
                            className={`dts ${index === activeIndex ? "dts-act" : ""}`}
                            onClick={() => setActiveIndex(index)} // Allow manual navigation (clickable dots)
                        ></span>
                    ))}
                </div>
                {/* <div className="project__small__img">
                        <img
                            alt=""
                            loading="lazy"
                            width="35"
                            height="32"
                            decoding="async"
                            data-nimg="1"
                            className="project__img__1"
                            src={Project8}
                            style={{ color: 'transparent' }}
                        />
                        <img
                            alt=""
                            loading="lazy"
                            width="35"
                            height="32"
                            decoding="async"
                            data-nimg="1"
                            className="project__img__2"
                            src={Project9}
                            style={{ color: 'transparent' }}
                        />
                    </div> */}

            </section>
            <div className="custom-bg">
                <Container className="text-center my-5">
                    <h2 className="heading py-3">IN THE NEWS</h2>
                    <Row className="mt-4 justify-content-center">
                        {visibleImages.map((img, index) => (
                            <Col
                                md={2}
                                sm={4}
                                xs={6}
                                className={`d-flex align-items-center justify-content-center mb-4 image-col ${index === 1 ? 'center-image' : ''}`}
                                key={index}
                            >
                                <Card style={{ border: "none" }} className="text-center">
                                    <Card.Img
                                        variant="top"
                                        src={img}
                                        alt={`Professional Trading Award ${index + 1}`}
                                        className="mx-auto image"
                                    />
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
            {/* textimonial */}
            <div class="pink__color"></div>
            <div className="project special__spacing sp_bottom_100 mb-3" id="project__area">
                <div className="project__margin">
                    <div className="container-fluid sp_top_100">
                        <div className="row align-items-center aos-init aos-animate" data-aos="fade-up" data-aos-duration="1500">
                            <div className="col-xl-4 col-lg-3 col-md-6 col-sm-12">
                                <div className="section__title section__title--2 sp_bottom_30">

                                    <div className="section__title__heading">
                                        <h3>Customer Reviews</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12">
                                <div className="project__bottom__img text-center">
                                    <img
                                        alt=""
                                        loading="lazy"
                                        width="183"
                                        height="67"
                                        decoding="async"
                                        src={Project}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="project__bottom__text">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <a href="/projects" style={{ textDecoration: 'none' }}>incididunt ut labore et dolore magna aliqua.</a> Ut enim ad minim veniam, quis nostrud exercitation.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container sp_top_30 sp_bottom_60">
                        <div className="row">
                            {/* Project 1 */}
                            <div className="col-xl-4 col-md-6 col-lg-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up" data-aos-duration="2400">
                                <div className="project__single single__transform">
                                    <div
                                        className="project__img project__img--2"
                                        onMouseEnter={() => setIsHoveredProject1(true)} // Trigger hover effect for Project 1
                                        onMouseLeave={() => setIsHoveredProject1(false)} // Reset hover effect for Project 1
                                        style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            loading="lazy"
                                            width="416"
                                            height="405"
                                            decoding="async"
                                            src={Project5}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                height: 'auto',
                                                transition: 'opacity 0.3s ease',
                                            }}
                                        />
                                        {/* Default black background with opacity for Project 1 */}
                                        <div
                                            className="overlay"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'black',
                                                opacity: 0.5, // Always have a 50% opacity black background
                                                transition: 'opacity 0.3s ease',
                                                pointerEvents: 'none',
                                            }}
                                        ></div>

                                        <div
                                            className="project__heading project__heading--2"
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: isHoveredProject1 ? 'white' : 'transparent',
                                                fontSize: '15px',
                                                opacity: isHoveredProject1 ? 1 : 0,
                                                transition: 'opacity 0.3s ease, color 0.3s ease',
                                                pointerEvents: 'none',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                                            </p>
                                        </div>

                                        <div className="project__icon project__icon--2">
                                            <a className="direction__btn" href="/projects/4">
                                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.4258 10.9897L23.0101 10.9897L23.0101 19.574" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M10.9902 23.0107L22.8908 11.1101" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Project 2 */}
                            <div className="col-xl-4 col-md-6 col-lg-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up" data-aos-duration="2600">
                                <div className="project__single single__transform">
                                    <div
                                        className="project__img project__img--2"
                                        onMouseEnter={() => setIsHoveredProject2(true)} // Trigger hover effect for Project 2
                                        onMouseLeave={() => setIsHoveredProject2(false)} // Reset hover effect for Project 2
                                        style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            loading="lazy"
                                            width="416"
                                            height="405"
                                            decoding="async"
                                            src={Project6}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                height: 'auto',
                                                transition: 'opacity 0.3s ease',
                                            }}
                                        />
                                        {/* Default black background with opacity for Project 2 */}
                                        <div
                                            className="overlay"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'black',
                                                opacity: 0.5, // Always have a 50% opacity black background
                                                transition: 'opacity 0.3s ease',
                                                pointerEvents: 'none',
                                            }}
                                        ></div>

                                        <div
                                            className="project__heading project__heading--2"
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: isHoveredProject2 ? 'white' : 'transparent', // Text turns white on hover
                                                fontSize: '15px',
                                                opacity: isHoveredProject2 ? 1 : 0,
                                                transition: 'opacity 0.3s ease, color 0.3s ease',
                                                pointerEvents: 'none',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                                            </p>
                                        </div>

                                        <div className="project__icon project__icon--2">
                                            <a className="direction__btn" href="/projects/5">
                                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.4258 10.9897L23.0101 10.9897L23.0101 19.574" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M10.9902 23.0107L22.8908 11.1101" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Project 3 */}
                            <div className="col-xl-4 col-md-6 col-lg-6 col-sm-6 col-12 aos-init aos-animate" data-aos="fade-up" data-aos-duration="2800">
                                <div className="project__single single__transform">
                                    <div
                                        className="project__img project__img--2"
                                        onMouseEnter={() => setIsHoveredProject3(true)} // Trigger hover effect for Project 3
                                        onMouseLeave={() => setIsHoveredProject3(false)} // Reset hover effect for Project 3
                                        style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            loading="lazy"
                                            width="416"
                                            height="405"
                                            decoding="async"
                                            src={Project7}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                height: 'auto',
                                                transition: 'opacity 0.3s ease',
                                            }}
                                        />
                                        {/* Default black background with opacity for Project 3 */}
                                        <div
                                            className="overlay"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'black',
                                                opacity: 0.5, // Always have a 50% opacity black background
                                                transition: 'opacity 0.3s ease',
                                                pointerEvents: 'none',
                                            }}
                                        ></div>

                                        <div
                                            className="project__heading project__heading--2"
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: isHoveredProject3 ? 'white' : 'transparent', // Text turns white on hover
                                                fontSize: '15px',
                                                opacity: isHoveredProject3 ? 1 : 0,
                                                transition: 'opacity 0.3s ease, color 0.3s ease',
                                                pointerEvents: 'none',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                                            </p>
                                        </div>

                                        <div className="project__icon project__icon--2">
                                            <a className="direction__btn" href="/projects/6">
                                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.4258 10.9897L23.0101 10.9897L23.0101 19.574" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M10.9902 23.0107L22.8908 11.1101" stroke="#FFFFFF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div className="project__small__img">
                        <img
                            alt=""
                            loading="lazy"
                            width="35"
                            height="32"
                            decoding="async"
                            data-nimg="1"
                            className="project__img__1"
                            src={Project8}
                            style={{ color: 'transparent' }}
                        />
                        <img
                            alt=""
                            loading="lazy"
                            width="35"
                            height="32"
                            decoding="async"
                            data-nimg="1"
                            className="project__img__2"
                            src={Project9}
                            style={{ color: 'transparent' }}
                        />
                    </div>


                </div>
            </div>





        </>






    );
};

export default BannerSection;
